import React from "react";
import AboutUsTestimonialImage1 from "../../images/justin-cunningham-profile.png";
import AboutUsTestimonialImage2 from "../../images/todd-profile.png";
import IconYodish from "../../images/icon-yodish.png";
import IconZurn from "../../images/icon-zurn.png";
import LazyLoad from 'react-lazyload';

export default function AboutUsTestimonial(props) {

  const testimonials = [
    {
      content: "Staying lean, failing fast, and learning quickly were important for our startup, and Rapidops team is the best at it.",
      image: AboutUsTestimonialImage1,
      authorName: "Justin Cunningham",
      authorPosition: "Founder, YoDish",
      icon: IconYodish,
      iconTitle: "Yodish"
    }, {
      content: "I am impressed how Rapidops can continuously discover and deliver outstanding software for our business. They far exceed my expectations.",
      image: AboutUsTestimonialImage2,
      authorName: "Todd",
      authorPosition: "Director of Marketing, Zurn",
      icon: IconZurn,
      iconTitle: "Zern"
    }
  ];

  return (
    <div className="about-testimonial-slider-section section-gap">
      <div className="container">
        <div className="">
          <div className="about-testimonial-content-block text-center section-gap-small">
            <h3 className="secondary-font">What is it like to work with us?</h3>
          </div>
          <div className="about-testimonial-slider-block">
            <ul className="row testimonial-slider-list d-flex flex-wrap">
              {testimonials.map((item, i) => {
                return <li className="col testimonial-slider-item" key={i}>
                  <div className="item-inner">
                    <div className="testimonial-text">
                      <p>{item.content}</p>
                    </div>
                    <div className="testimonial-bottom-block d-flex flex-wrap align-v-center justify-space">
                      <div className="testimonial-author-block d-flex flex-wrap align-v-center">
                        <div className="author-image">
                          <LazyLoad key={i}>
                            <img src={item.image} alt={item.authorName} title={item.authorName} />
                          </LazyLoad>
                        </div>
                        <div className="author-detail">
                          <h5>{item.authorName}</h5>
                          <span>{item.authorPosition}</span>
                        </div>
                      </div>
                      <div className="testimonial-brand-logo"><img src={item.icon} width="110" title={item.iconTitle} alt={item.iconTitle} /></div>
                    </div>
                  </div>
                </li>;
              })}
            </ul>
          </div>
        </div>
      </div>
      

    </div>

  );
}
